import {
    FETCH_REPORTS, FETCH_REPORTS_SUCCESS, FETCH_REPORTS_FAILURE,
    EMPTY_REPORTS, UPDATE_REPORTS
} from './constants';

const initialState = {
    allReports: [],
    timing: {
        totalAssignments: 'all_time',
        uniqueAssignments: 'all_time',
        uniqueUsers: 'all_time',
        timeSpentInAssignments: 'all_time',
        averageTimeSpentInAssignments: 'all_time',
        averageTimeSpentInContent: 'all_time',
        uniqueContents: 'all_time',
        popularContents: 'all_time',
        percentAssignmentsPinPoints: 'all_time'
    },
    isFetching: false,
    error: {}
};

function reportsReducer(state = initialState, action) {
    switch(action.type) {
        case FETCH_REPORTS:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case FETCH_REPORTS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                allReports: action.data
            });
        case FETCH_REPORTS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case EMPTY_REPORTS:
            return initialState;
        case UPDATE_REPORTS:
            return Object.assign({}, state, action.data);
        default:
            return state;
    }
}

export default reportsReducer;



// WEBPACK FOOTER //
// ./src/containers/ReportsPage/store/reducers.js